import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/functions";
import { useAuthState } from "react-firebase-hooks/auth";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme, CssBaseline } from "@material-ui/core";
import { useToggleTheme, useBaristaStation } from "hooks";
import { AppContext } from "store/context";
import themeConfig from "styles/themeConfig";
import { PrivateRoute, Callback, Error, NotFound, MainLayout } from "routes";
import firebaseConfig from "firebaseConfig";

firebase.initializeApp(firebaseConfig);

if (process.env.NODE_ENV !== "production") {
  firebase.functions().useFunctionsEmulator("http://localhost:5001");
}

const App = () => {
  const [user, loading] = useAuthState(firebase.auth());
  const { theme, toggleTheme } = useToggleTheme(themeConfig);
  const { station } = useBaristaStation();

  if (loading || !station) {
    return null;
  }

  return (
    <AppContext.Provider value={{ firebase, user, station, toggleTheme }}>
      <HelmetProvider>
        <Helmet titleTemplate="%s | Barista Station" defaultTitle="Barista Station" />
        <ThemeProvider theme={createMuiTheme(theme)}>
          <CssBaseline />
          <Router>
            <Switch>
              <PrivateRoute
                authed={user !== null}
                device_id={station.id}
                path={["/", "/orders", "/orders/history"]}
                component={MainLayout}
                exact
              />
              <Route path="/callback" component={Callback} exact />
              <Route path="/error" component={Error} exact />
              <Route component={NotFound} />
            </Switch>
          </Router>
        </ThemeProvider>
      </HelmetProvider>
    </AppContext.Provider>
  );
};

export default App;
